import * as React from 'react';
import { 
  DeluxeContext,
  DeluxeActionButton,
} from '../';
import { Title } from '../../title';

export const Terms = () => {
  return (
    <DeluxeContext.Consumer>
      {({ currentSelection }) => {
        const { payment: { period } } = currentSelection;
        const isMonth = period === 'month';
        const termsTitle = isMonth ? 'maandelijks opzegbaar' : '1, 2 EN 3 JAAR';        
        return (
          <>
            <Title Tag='h1'>   
              Actievoorwaarden {termsTitle}
            </Title>
            <ul style={{ lineHeight: '4rem' }}>
              <li>
                De actie wordt georganiseerd door Dumpert ‘Mediahuis Nederland B.V.’ 
                gevestigd en kantoorhoudende te (1043 AP Amsterdam aan de Basisweg 30 (hierna “Mediahuis”)).
              </li>
              <li>Je hebt direct na afsluiten toegang tot Dumpert Deluxe.</li>
              <li>Binnen 24 uur na uw aanvraag krijg je een bevestigingsmail.</li>
              <li>Om te profiteren van dit aanbod dien je 18 jaar of ouder te zijn.</li>
              <li>De actie is niet geldig in combinatie met andere acties of aanbiedingen.</li>
              <li>
                Mediahuis behoudt zich het recht om te allen tijde en zonder opgaaf van 
                redenen de actie eenzijdig te wijzigen, op te schorten of te beëindigen.
              </li>
              <li>Door deelname aan deze actie geef je aan akkoord te zijn de actievoorwaarden.</li>  
              {!isMonth && 
                <li>
                  Je betaalt na de actieperiode het dan geldende, reguliere tarief. 
                  Daarnaast is jouw abonnement na de actieperiode maandelijks opzegbaar. 
                  Hierbij geldt een opzegtermijn van 30 dagen.
                </li>
              }
              {isMonth && 
                <li>
                  Je betaalt per maand het reguliere tarief. 
                  Het abonnement is maandelijks opzegbaar. 
                  Hierbij geldt een opzegtermijn van 30 dagen.
                </li>
              }
            </ul>
            <br />
            <DeluxeActionButton back />
          </>
        );
      }}
    </DeluxeContext.Consumer>
  );
};